import { PERMISSIONS } from '@tempo-io/permissions';
import { defineNotificationCategory } from './types';

const actionUrl = (
  data: { loopId?: number | null; insightId: string },
  organizationId: string,
): string =>
  data.loopId != null
    ? `/org-id/${organizationId}/loop/${data.loopId}/overview`
    : `/org-id/${organizationId}`;

export const newCriticalInsightDescriptor = defineNotificationCategory('new_critical_insight', {
  actionUrl,
  nonDisableable: true,
  pills: () => ['Insights'],
  audience: PERMISSIONS.VIEW_INSIGHTS,
  scope: 'entity',
  defaultChannels: ['email', 'in_app'],
});

export const newHighInsightDescriptor = defineNotificationCategory('new_high_insight', {
  actionUrl,
  pills: () => ['Insights'],
  audience: PERMISSIONS.VIEW_INSIGHTS,
  scope: 'entity',
  defaultChannels: ['email', 'in_app'],
});
